export function LocalBuzzContent({ newsData }) {
  let featuredArticles = [];
  let newsItems = [];
  let secondaryArticles = [];

  // Loop through newsData
  newsData.forEach(newsCategory => {
    if (newsCategory.category === "US") {
      featuredArticles.push(...newsCategory.news.slice(0, 2));
      newsItems = newsCategory.news.slice(2);
    } else {
      if (newsCategory.news.length > 0) {
        secondaryArticles.push(...newsCategory.news);
      }
    }
  });


  return (
    <div className="flex-1 overflow-auto w-full">
      <div className="flex flex-col xl:flex-row">
        {/* Main Content */}
        <div className="flex-1 p-4 sm:p-5 lg:p-6 overflow-y-auto">
          {/* Date and Title */}
          <div className="mb-5 sm:mb-6">
            <div className="text-sm text-[#4f4d4f] mb-2">
            {new Date().toLocaleDateString('en-GB', {
              weekday: 'long',
              day: 'numeric',
              month: 'short',
            })}
            </div>

            <h1 className="text-2xl sm:text-[28px] font-bold text-[#232123] mb-2 leading-tight">
              Local Buzz for you
            </h1>
            <p className="text-sm text-[#4f4d4f] leading-relaxed">
              Stay updated with the latest happenings in your neighborhood.
            </p>
          </div>

          {/* Featured Articles Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 lg:gap-6 mb-5 sm:mb-6">
            {featuredArticles.map(article => (
              <div
                key={article.id}
                className="bg-white rounded-md overflow-hidden border border-[#F5E8EA] cursor-pointer hover:shadow-sm transition-shadow"
              >
                <div className="w-full">
                  <img
                    src={article.imageurl || "/placeholder.svg"}
                    alt={article.subject}
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="lazy"
                  />
                </div>

                <div
                  onClick={() => window.open(article.sourceurl, "_blank")}
                  className="p-3 sm:p-4"
                >
                  <h3 className="font-semibold text-base sm:text-lg text-[#232123] mb-2 sm:mb-3 leading-tight line-clamp-2">
                    {article.subject}
                  </h3>
                  <div className="flex items-center justify-between text-xs text-[#777280]">
                    <span>{article.source}</span>
                    <span>{article.readTime}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Secondary Articles Grid - Optimized for 800-1200px range */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-5">
            {secondaryArticles.map(article => (
              <div
                key={article.id}
                className="bg-white rounded-md overflow-hidden border border-[#F5E8EA] cursor-pointer hover:shadow-sm transition-shadow"
              >
                <div className="w-full">
                  <img
                    src={article.imageurl || "/placeholder.svg"}
                    alt={article.subject}
                    className="w-full h-auto object-cover aspect-[1/1]"
                    loading="lazy"
                  />
                </div>
                <div
                  onClick={() => window.open(article.sourceurl, "_blank")}
                  className="p-2 sm:p-3"
                >
                  <h3 className="font-semibold text-xs sm:text-sm text-[#232123] mb-1.5 sm:mb-2 leading-tight line-clamp-2">
                    {article.subject}
                  </h3>
                  <div className="flex items-center justify-between text-[10px] sm:text-xs text-[#777280]">
                    <span className="truncate max-w-[70px] sm:max-w-[100px] md:max-w-none">
                      {article.source}
                    </span>
                    <span>{article.readTime}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Sidebar - Optimized for 800-1200px range */}
      </div>
    </div>
  );
}
